import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal, Toast } from '@ow/comps'
import { getQuery } from '@vt/utils'
import { pick, get, findIndex } from 'lodash-es'
import { Radio, Select, Card, Text, Checkbox, Tooltip } from '@mantine/core'
import { IconChevronDown } from '@tabler/icons'
import { buildQueries } from '@vt/apis/lib-ex/utils/transformers'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import useProjectStore from '@vt/hooks/lib/project/use-project-store'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { IconMaps } from '@ow/icons'
import {
  easyDownloadData,
  easyDownloadUrl,
  createGenerateTask,
} from '@vt/apis/lib-ex/v2/givrali'
import { fetchTreeHeight } from '@vt/apis/lib-ex/v2/area'
import { getDownloaderFiles } from '@vt/apis/lib-ex/v2/downloadCenter'

// 目前没有办法定制，写死判断一下大连  group: type,
//  group: type,
const DOWNLOAD_STATEMENT_URL =
  'https://ugm.oss-cn-beijing.aliyuncs.com/ele_download/download_doc/%E4%B8%8B%E8%BD%BD%E5%99%A8%E4%BD%BF%E7%94%A8%E6%96%87%E6%A1%A3.pdf'
const hanNum = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
const protocolName =
  process.env.REACT_APP_DEP === 'dev'
    ? 'qydownloadnormaltest'
    : 'qydownloadnormal'

const fileSizeArr = [
  {
    label: '100M',
    value: '100',
    defaultChecked: true,
  },
  {
    label: '200M',
    value: '200',
  },
  {
    label: '500M',
    value: '500',
  },
  {
    label: '1G',
    value: '1024',
  },
  {
    label: '2G',
    value: '2048',
  },
]
const Footer = function (close, exportAllFn, defaultFn) {
  return (
    <div className="flex">
      <Button
        className="mr-2"
        type="secondary"
        opacityType="sm"
        onClick={() => {
          if (defaultFn) defaultFn()
          close()
        }}
      >
        取消
      </Button>
      <Button
        className="mr-2"
        type="primary"
        onClick={() => {
          exportAllFn()
          close()
        }}
      >
        导出
      </Button>
    </div>
  )
}
const Footerfolder = function (setFolderOpen, exportFolderFn) {
  return (
    <div className="flex">
      <Button
        className="mr-2"
        type="secondary"
        opacityType="sm"
        onClick={() => {
          setFolderOpen(false)
        }}
      >
        取消
      </Button>
      <Button
        className="mr-2"
        type="primary"
        onClick={() => {
          exportFolderFn()
        }}
      >
        导出
      </Button>
    </div>
  )
}
const Exporter = function ({ children }) {
  const { tpl, type: groupType } = getQuery()

  const { appId, tbs } = useAppEx()
  const [type, setType] = useState('filters') // 导出类型
  const [downloadType, setDownloadType] = useState('') // 下载类型
  const [downloadSize, setDownloadSize] = useState('100') // 文件大小
  const [pictureType, setPictureType] = useState('hasPicture') // 图片
  const [waterMarkType, setWaterMarkType] = useState('noWaterMark') // 水印
  const [thumbnailMarkType, setThumbnailMarkType] = useState('noThumbnail') // 缩略图
  const [showDownLoad, setShowDownLoad] = useState(false) // 下载器弹窗
  const [folderOpen, setFolderOpen] = useState(false) // 图片文件夹弹窗
  const [taskId, setTaskId] = useState('') // 任务id
  const [standardArr, setStandardArr] = useState([]) // 指标
  const [areaArr, setAreaArr] = useState([]) // 点位
  const [checkedAreaArr, setCheckedAreaArr] = useState([]) // 选中的点位数组
  const [checkedStandArr, setCheckedStandArr] = useState([]) // 选中的指标数组
  const [dateFormat, setDateFormat] = useState('month') // 上报日期
  const [pictureArr, setPictureArr] = useState([])
  const [optionsArr, setOptionsArr] = useState([])
  const [pictureDownloadArr, setPictureDownloadArr] = useState([])
  const [noPictureDownloadArr, setNoPictureDownloadArr] = useState([])
  const [isCheckObj, setIsCheckObj] = useState({
    area: false,
    standard: false,
    createdBy: false,
    createdAt: false,
    tableDataId: false,
  })
  const [downloaderUrl, setDownloaderUrl] = useState('')
  const {
    tbId,
    exporterConfig,
    id,
    // filters,
    finalFetchDataFilters,
    selectedIds,
    defaultFilters,
    sorts,
  } = useTbViewStore((state) =>
    pick(state, [
      'tbId',
      'exporterConfig',
      'id',
      // 'filters',
      'finalFetchDataFilters',
      'selectedIds',
      'defaultFilters',
      'sorts',
    ])
  )
  const [folderConfig, setFolderConfig] = useState(
    get(exporterConfig, 'folderConfig', [])
  )
  const { getToken } = useProjectStore((s) => pick(s, ['getToken']))
  const token = getToken()
  const waterMark = [
    {
      label: '带水印',
      value: 'WaterMark',
    },
    {
      label: '不带水印',
      value: 'noWaterMark',
      defaultChecked: true,
    },
  ]
  const thumbnailMark = [
    {
      label: '不缩略',
      value: 'noThumbnail',
      defaultChecked: true,
    },
    {
      label: '缩略',
      value: 'thumbnail',
    },
  ]
  const dateFormatArr = [
    {
      label: '年月',
      value: 'month',
      defaultChecked: true,
    },
    {
      label: '年月日',
      value: 'date',
    },
  ]

  let fetchUrl = ''
  const url = get(exporterConfig, 'url', '')
  if (url) {
    fetchUrl = `apps/${appId}/${url}`
  } else {
    fetchUrl = 'dynamic_report/createGenerateTask'
  }
  const choosePicture = get(exporterConfig, 'choosePicture', {})

  const props = useMemo(() => {
    if (tpl === 'dlljflxzsj' && groupType) {
      return { group: groupType }
    }
    return {}
  }, [])

  useEffect(() => {
    const options = []
    const picture = []
    const pictureDownload = []
    const noPictureDownload = []
    const exporterAll = get(exporterConfig, 'exporterAll', false)
    const exporterFilters = get(exporterConfig, 'exporterFilters', false)
    const exporterChecked = get(exporterConfig, 'exporterChecked', false)
    const exporterAllFolder = get(exporterConfig, 'exporterAllFolder', false)
    const exporterFiltersFolder = get(
      exporterConfig,
      'exporterFiltersFolder',
      false
    )

    if (exporterAll) {
      options.push({ label: '导出全部（Excel）', value: 'all' })
    }
    if (exporterFilters) {
      options.push({
        label: '导出筛选条件下的数据（Excel）',
        value: 'filters',
        defaultChecked: true,
      })
    }
    if (exporterChecked && selectedIds.length) {
      options.push({
        label: '导出选中的数据（Excel）',
        value: 'checked',
        disabled: !selectedIds.length,
      })
    }
    if (exporterAllFolder) {
      options.push({
        label: '导出全部图片（图片文件夹）',
        value: 'allFolder',
      })
    }
    if (exporterFiltersFolder) {
      options.push({
        label: '导出当前筛选条件下的图片（图片文件夹）',
        value: 'filtersFolder',
      })
    }
    setOptionsArr(options)

    if (choosePicture && choosePicture.hasPicture) {
      picture.push({
        label: '有图片',
        value: 'hasPicture',
        defaultChecked: true,
      })
      pictureDownload.push({
        label: '下载器（数量无限制）',
        value: '下载器生成',
        defaultChecked: true,
      })
    }
    if (choosePicture && choosePicture.noPicture) {
      picture.push({
        label: '无图片',
        value: 'noPicture',
      })
      if (choosePicture.noPicture.allowDownloader) {
        noPictureDownload.push({
          label: '下载器（数量无限制）',
          value: '下载器生成',
        })
      }
      if (choosePicture.noPicture.allowBrowser) {
        noPictureDownload.push({
          label: '浏览器（最多支持导出当前条件下的10000条数据）',
          value: '浏览器下载',
          defaultChecked: true,
        })
      }
    }
    setPictureDownloadArr(pictureDownload)
    setNoPictureDownloadArr(noPictureDownload)
    setPictureArr(picture)

    if (exporterAllFolder) {
      setDownloadType('下载器生成')
      fetchTreeHeight(appId).then((res) => {
        const standard = []
        hanNum.slice(0, res.standard).forEach((han, i) => {
          standard.push({
            title: `${han}级指标`,
            type: 'standard',
            slug: `standard_${i}`,
            showType: 'sticky',
          })
        })
        const area = []
        hanNum.slice(0, res.area).forEach((han, i) => {
          area.push({
            title: `${han}级点位`,
            type: 'area',
            slug: `area_${i}`,
            showType: 'sticky',
          })
        })
        setStandardArr(standard)
        setAreaArr(area)
      })
    } else if (
      choosePicture.hasPicture &&
      choosePicture.hasPicture.allowDownloader
    ) {
      setDownloadType('下载器生成')
    } else {
      setDownloadType('浏览器下载')
    }
    if (!exporterFilters && exporterFiltersFolder) {
      setType('filtersFolder')
    }
  }, [selectedIds])
  const initDownloadInfo = async () => {
    const { pro2downloader32 = {} } = await getDownloaderFiles(appId)
    if (pro2downloader32.url) setDownloaderUrl(pro2downloader32.url)
  }
  useEffect(() => {
    initDownloadInfo()
  }, [])

  const defaultFn = () => {
    setType('filters')
    setPictureType('hasPicture')
    setWaterMarkType('noWaterMark')
    setDownloadType('下载器生成')
    setDownloadSize('100')
    setPictureArr([
      {
        label: '有图片',
        value: 'hasPicture',
        defaultChecked: true,
      },
      {
        label: '无图片',
        value: 'noPicture',
      },
    ])
  }
  const exportAllFn = () => {
    const childQueries = []
    // 判断是否是es（远洋的）
    if (tbs[tbId] && tbs[tbId].existElasticSearch) {
      selectedIds.map((item) => {
        childQueries.push({
          queryType: 'just',
          yacQueryOperate: {
            operator: 'equal',
            left: {
              slug: 'id',
            },
            right: {
              value: item,
            },
          },
        })
        return selectedIds
      })
    } else {
      // 通用的
      selectedIds.map((item) => {
        childQueries.push({
          queryType: 'just',
          yacQueryOperate: {
            operator: 'equal',
            left: {
              slug: 'objectId',
            },
            right: {
              value: item,
            },
          },
        })
        return selectedIds
      })
    }
    const checkedData = {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'or',
          childQueries,
        },
      ],
    }

    const getdsl = (exporterType) => {
      let dslobj
      switch (exporterType) {
        case 'checked':
          dslobj = checkedData
          break
        case 'filters':
          dslobj = buildQueries({ filters: finalFetchDataFilters })

          break
        default:
          dslobj = buildQueries({
            filters: {
              logicType: 'and',
              queries: [
                ...defaultFilters.queries,
                {
                  slug: 'isFakeDeleted',
                  value: true,
                  queryType: ['notEqual'],
                },
              ],
            },
          })
          break
      }
      return dslobj
    }
    const data = {
      originTid: tbId,
      appId,
      state: 'WAITING',
      picture: pictureType === 'hasPicture',
      taskType: downloadType,
      viewId: id,
      waterMark: waterMarkType === 'WaterMark',
      extConfig: {
        isThumbnail: thumbnailMarkType === 'thumbnail',
      },
      limitSize: downloadSize * 1,
      dsl: getdsl(type),
    }
    if (type === 'allFolder') {
      setFolderOpen(true)
    } else if (type === 'filtersFolder') {
      setFolderOpen(true)
    } else if (downloadType === '下载器生成') {
      createGenerateTask(fetchUrl, data).then((res) => {
        setTaskId(res.data)
        setShowDownLoad(true)
      })
    } else if (type === 'all') {
      // 导出全部
      easyDownloadData({
        appId,
        tbId,
        viewId: id,
        filters: {
          logicType: 'and',
          queries: [
            ...defaultFilters.queries,
            {
              slug: 'isFakeDeleted',
              value: true,
              queryType: ['notEqual'],
            },
          ],
        },
        sorts,
        type: 'all',
        props,
      }).then((res) => {
        window.open(easyDownloadUrl(appId, res, token))
      })
    } else if (type === 'checked') {
      easyDownloadData({
        appId,
        tbId,
        viewId: id,
        filters: { ...checkedData, size: 50, page: 0 },
        sorts,
        type: 'checked',
        props,
      }).then((res) => {
        window.open(easyDownloadUrl(appId, res, token))
      })
    } else {
      // 导出筛选条件
      easyDownloadData({
        appId,
        tbId,
        viewId: id,
        filters: finalFetchDataFilters,
        sorts,
        type: 'all',
        props,
      }).then((res) => {
        window.open(easyDownloadUrl(appId, res, token))
      })
    }
  }
  const exportFolderFn = () => {
    if (isCheckObj.area && !checkedAreaArr.length) {
      Toast.error({
        title: '请选择点位',
      })
      return
    }
    if (isCheckObj.standard && !checkedStandArr.length) {
      Toast.error({
        title: '请选择指标',
      })
      return
    }
    const newfolderConfig = []
    folderConfig.forEach((v) => {
      if (v.slug === 'createdBy' && isCheckObj.createdBy) {
        newfolderConfig.push(v)
      }
      if (v.slug === 'tableDataId' && isCheckObj.tableDataId) {
        newfolderConfig.push(v)
      }
      if (v.slug === 'createdAt' && isCheckObj.createdAt) {
        newfolderConfig.push({
          ...v,
          format: dateFormat === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM',
        })
      }
      if (v.slug === 'area' && isCheckObj.area) {
        const areas = []
        checkedAreaArr.map((val) => {
          return areas.push({
            index: val,
            nodeType: 'ARRAY',
            slug: 'area',
            title: '点位',
          })
        })
        newfolderConfig.push(...areas)
      }
      if (v.slug === 'standard' && isCheckObj.standard) {
        const stands = []
        checkedStandArr.map((value) => {
          return stands.push({
            index: value,
            nodeType: 'ARRAY',
            slug: 'standard',
            title: '指标',
          })
        })
        newfolderConfig.push(...stands)
      }
      return v
    })
    const getdsl = (exporterType) => {
      let dslobj
      switch (exporterType) {
        case 'filtersFolder':
          dslobj = buildQueries({ filters: finalFetchDataFilters })
          break
        default:
          dslobj = buildQueries({
            filters: {
              logicType: 'and',
              queries: [
                ...defaultFilters.queries,
                {
                  slug: 'isFakeDeleted',
                  value: true,
                  queryType: ['notEqual'],
                },
              ],
            },
          })
          break
      }
      return dslobj
    }
    const data = {
      dsl: getdsl(type),
      dir: newfolderConfig,
      // 从哪个表单id 获取数据
      originTid: tbId,
      appId,
      taskType: '图片包',
      waterMark: waterMarkType === 'WaterMark',
      extConfig: {
        isThumbnail: thumbnailMarkType === 'thumbnail',
      },
      // 数据结果存储至那个表单
      targetTid: 527,
      viewId: id,
    }
    createGenerateTask(fetchUrl, data).then((res) => {
      setTaskId(res.data)
      setShowDownLoad(true)
      setFolderOpen(false)
      setCheckedAreaArr([])
      setCheckedStandArr([])
      setIsCheckObj({
        area: false,
        createdAt: false,
        createdBy: false,
        standard: false,
        tableDataId: false,
      })
    })
  }
  const onChangeCheck = (slug, isSelected) => {
    const num = findIndex(areaArr, (v) => v.slug === slug)
    const arr = [...checkedAreaArr]
    if (isSelected) {
      arr.push(num)
    } else {
      arr.forEach((q, i) => {
        if (q === num) {
          arr.splice(i, 1)
        }
      })
    }
    setCheckedAreaArr(arr)
  }
  const onChangeCheckStand = (slug, isSelected) => {
    const num = findIndex(standardArr, (v) => v.slug === slug)
    const arr = [...checkedStandArr]
    if (isSelected) {
      arr.push(num)
    } else {
      arr.forEach((q, i) => {
        if (q === num) {
          arr.splice(i, 1)
        }
      })
    }
    setCheckedStandArr(arr)
  }
  const changeDateFormat = (e) => {
    setDateFormat(e)
    const newArr = folderConfig.map((v) => {
      if (v.nodeType === 'DATE') {
        v.format = e === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM'
      }
      return v
    })
    setFolderConfig(newArr)
  }
  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }
    const arr = [...folderConfig]
    const data = arr[result.source.index]
    arr.splice(result.source.index, 1)
    arr.splice(result.destination.index, 0, data)
    setFolderConfig(arr)
  }
  const changeType = (e) => {
    setType(e)
    if (e === 'allFolder' || e === 'filtersFolder') {
      setPictureArr([
        {
          label: '有图片',
          value: 'hasPicture',
          defaultChecked: true,
        },
      ])
      setPictureType('hasPicture')
    } else {
      const pictures = []
      if (choosePicture && choosePicture.hasPicture) {
        pictures.push({
          label: '有图片',
          value: 'hasPicture',
          defaultChecked: true,
        })
      }
      if (choosePicture && choosePicture.noPicture) {
        pictures.push({
          label: '无图片',
          value: 'noPicture',
        })
      }
      setPictureArr(pictures)
    }
  }
  return (
    <>
      <Modal
        nested
        size="sm"
        title="导出"
        trigger={children}
        showCloseButton
        footer={({ close }) => {
          return Footer(
            close,
            exportAllFn,
            pictureArr.length > 0 ? defaultFn : null
          )
        }}
      >
        <>
          <div style={{ fontSize: '14px', fontWeight: 500, color: '#212529' }}>
            请选择导出内容：
          </div>
          <Select
            rightSection={<IconChevronDown size={18} />}
            className="mt-4"
            data={optionsArr}
            value={type}
            style={{ width: '100%' }}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            onChange={changeType}
          />
          {pictureArr.length !== 0 && (
            <div className="mt-4">
              <Radio.Group
                orientation="vertical"
                label="请选择图片类型："
                value={pictureType}
                onChange={setPictureType}
              >
                {pictureArr.map((v, index) => {
                  return (
                    <Radio
                      value={v.value}
                      label={v.label}
                      key={`pictureArr-radio-${index}`}
                    />
                  )
                })}
              </Radio.Group>
              {pictureType === 'hasPicture' && (
                <div className="mt-4">
                  <Radio.Group
                    orientation="vertical"
                    label="请选择是否添加水印："
                    value={waterMarkType}
                    onChange={setWaterMarkType}
                  >
                    {waterMark.map((v, index) => {
                      return (
                        <Radio
                          value={v.value}
                          label={v.label}
                          key={`waterMark-radio-${index}`}
                        />
                      )
                    })}
                  </Radio.Group>
                  <div className="mt-4">
                    <Radio.Group
                      orientation="vertical"
                      label="请选择是否下载缩略图"
                      value={thumbnailMarkType}
                      onChange={setThumbnailMarkType}
                    >
                      {thumbnailMark.map((v, index) => {
                        return (
                          <Radio
                            value={v.value}
                            label={v.label}
                            key={`thumbnailMark-radio-${index}`}
                          />
                        )
                      })}
                    </Radio.Group>
                  </div>
                  <div className="mt-4">
                    <Radio.Group
                      orientation="vertical"
                      label="请选择下载方式："
                      value={downloadType}
                      onChange={setDownloadType}
                    >
                      {pictureDownloadArr.map((v, index) => {
                        return (
                          <Radio
                            value={v.value}
                            label={v.label}
                            key={`pictureDonwloadArr-radio-${index}`}
                          />
                        )
                      })}
                    </Radio.Group>
                  </div>
                  <div className="mt-4">
                    <Radio.Group
                      label="请选择下载的文件大小："
                      value={downloadSize}
                      onChange={setDownloadSize}
                    >
                      {fileSizeArr.map((v, index) => {
                        return (
                          <Radio
                            value={v.value}
                            label={v.label}
                            key={`fileSizeArr-radio-${index}`}
                          />
                        )
                      })}
                    </Radio.Group>
                  </div>
                </div>
              )}
              {pictureType === 'noPicture' && (
                <div className="mt-4">
                  <Radio.Group
                    orientation="vertical"
                    label="请选择下载方式："
                    value={downloadType}
                    onChange={setDownloadType}
                  >
                    {noPictureDownloadArr.map((v, index) => {
                      return (
                        <Radio
                          value={v.value}
                          label={v.label}
                          key={`noPictureDownloadArr-radio-${index}`}
                        />
                      )
                    })}
                  </Radio.Group>
                </div>
              )}
            </div>
          )}
        </>
      </Modal>
      <Modal
        nested
        size="lg"
        title="导出"
        open={folderOpen}
        showCloseButton
        onClose={() => setFolderOpen(false)}
        closeOnDocumentClick={false}
        footer={() => {
          return Footerfolder(setFolderOpen, exportFolderFn)
        }}
      >
        <>
          <div style={{ fontSize: '14px', fontWeight: 500, color: '#212529' }}>
            请选择导出文件夹层级：
          </div>

          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="columns-droppable">
              {(dropableProvided) => (
                <div
                  {...dropableProvided.droppableProps}
                  ref={dropableProvided.innerRef}
                  // className={clsx(themeClass, 'w-full overflow-y-auto h-72')}
                  style={{
                    fontSize: '0.875rem',
                    color: 'var(--ow-color-gray-100)',
                  }}
                >
                  {folderConfig.map((item, index) => {
                    return (
                      <Draggable
                        key={item.slug}
                        draggableId={item.slug}
                        index={index}
                      >
                        {(providedItem, snapshotItem) => (
                          <div
                            className="draggable"
                            ref={providedItem.innerRef}
                            {...providedItem.draggableProps}
                            {...providedItem.dragHandleProps}
                            // eslint-disable-next-line react/no-unknown-property
                            isDragging={snapshotItem.isDragging}
                          >
                            {item.slug === 'area' && (
                              <Card
                                withBorder
                                shadow="sm"
                                radius="md"
                                className="mt-3"
                              >
                                <Card.Section withBorder inheritPadding py="xs">
                                  <div className="flex justify-between items-center">
                                    <Checkbox
                                      label="点位"
                                      style={{
                                        fontWeight: 800,
                                      }}
                                      onChange={(e) => {
                                        setIsCheckObj({
                                          ...isCheckObj,
                                          area: e.currentTarget.checked,
                                        })
                                      }}
                                    />
                                    <IconMaps
                                      type="move"
                                      width={16}
                                      height={16}
                                    />
                                  </div>
                                </Card.Section>
                                <Text
                                  mt="sm"
                                  color="dimmed"
                                  size="sm"
                                  className="flex flex-wrap"
                                >
                                  {areaArr.length &&
                                    areaArr.map((v) => {
                                      return (
                                        <Checkbox
                                          onChange={(e) => {
                                            onChangeCheck(
                                              v.slug,
                                              e.currentTarget.checked
                                            )
                                          }}
                                          label={v.title}
                                          style={{ margin: '0 10px 10px 0' }}
                                        />
                                      )
                                    })}
                                </Text>
                              </Card>
                            )}
                            {item.slug === 'standard' && (
                              <Card
                                withBorder
                                shadow="sm"
                                radius="md"
                                className="mt-3"
                              >
                                <Card.Section withBorder inheritPadding py="xs">
                                  <div className="flex justify-between items-center">
                                    <Checkbox
                                      label="指标"
                                      style={{
                                        fontWeight: 800,
                                      }}
                                      onChange={(e) => {
                                        setIsCheckObj({
                                          ...isCheckObj,
                                          standard: e.currentTarget.checked,
                                        })
                                      }}
                                    />
                                    <IconMaps
                                      type="move"
                                      width={16}
                                      height={16}
                                    />
                                  </div>
                                </Card.Section>
                                <Text
                                  mt="sm"
                                  color="dimmed"
                                  size="sm"
                                  className="flex flex-wrap"
                                >
                                  {standardArr.length &&
                                    standardArr.map((v) => {
                                      return (
                                        <Checkbox
                                          onChange={(e) => {
                                            onChangeCheckStand(
                                              v.slug,
                                              e.currentTarget.checked
                                            )
                                          }}
                                          label={v.title}
                                          style={{ marginRight: '10px' }}
                                        />
                                      )
                                    })}
                                </Text>
                              </Card>
                            )}
                            {item.nodeType === 'DATE' && (
                              <Card
                                withBorder
                                shadow="sm"
                                radius="md"
                                className="mt-3"
                              >
                                <Card.Section withBorder inheritPadding py="xs">
                                  <div className="flex justify-between items-center">
                                    <Checkbox
                                      label="上报日期"
                                      style={{
                                        fontWeight: 800,
                                      }}
                                      onChange={(e) => {
                                        setIsCheckObj({
                                          ...isCheckObj,
                                          createdAt: e.currentTarget.checked,
                                        })
                                      }}
                                    />
                                    <IconMaps
                                      type="move"
                                      width={16}
                                      height={16}
                                    />
                                  </div>
                                </Card.Section>
                                <Radio.Group
                                  value={dateFormat}
                                  onChange={changeDateFormat}
                                >
                                  {dateFormatArr.map((v, i) => {
                                    return (
                                      <Radio
                                        value={v.value}
                                        label={v.label}
                                        key={`dateFormatArr-radio-${i}`}
                                      />
                                    )
                                  })}
                                </Radio.Group>
                              </Card>
                            )}
                            {item.slug === 'createdBy' && (
                              <Card
                                withBorder
                                shadow="sm"
                                radius="md"
                                className="mt-3"
                              >
                                <Card.Section withBorder inheritPadding py="xs">
                                  <div className="flex justify-between items-center">
                                    <Checkbox
                                      label={item.title}
                                      style={{
                                        fontWeight: 800,
                                      }}
                                      onChange={(e) => {
                                        setIsCheckObj({
                                          ...isCheckObj,
                                          createdBy: e.currentTarget.checked,
                                        })
                                      }}
                                    />
                                    <IconMaps
                                      type="move"
                                      width={16}
                                      height={16}
                                    />
                                  </div>
                                </Card.Section>
                              </Card>
                            )}
                            {item.slug === 'tableDataId' && (
                              <Card
                                withBorder
                                shadow="sm"
                                radius="md"
                                className="mt-3"
                              >
                                <Card.Section withBorder inheritPadding py="xs">
                                  <div className="flex justify-between items-center">
                                    <Checkbox
                                      label={item.title}
                                      style={{
                                        fontWeight: 800,
                                      }}
                                      onChange={(e) => {
                                        setIsCheckObj({
                                          ...isCheckObj,
                                          tableDataId: e.currentTarget.checked,
                                        })
                                      }}
                                    />
                                    <IconMaps
                                      type="move"
                                      width={16}
                                      height={16}
                                    />
                                  </div>
                                </Card.Section>
                              </Card>
                            )}
                          </div>
                        )}
                      </Draggable>
                    )
                  })}
                  {dropableProvided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </>
      </Modal>
      <Modal
        size="sm"
        title="创建成功"
        showCloseButton
        open={showDownLoad}
        onClose={() => setShowDownLoad(false)}
      >
        <div className="text-white-400" style={{ fontSize: '12px' }}>
          下载任务 <span className="text-primary-700">{taskId}</span>{' '}
          创建成功，请在下载工具中下载文件
        </div>
        {downloaderUrl && (
          <div
            className="mt-2 cursor-pointer"
            style={{ color: 'rgb(var(--ow-primary-color))', fontSize: '12px' }}
          >
            <a href={downloaderUrl}>安装下载工具</a>
          </div>
        )}
        {downloaderUrl && (
          <div
            className="mt-2 cursor-pointer"
            style={{ color: 'rgb(var(--ow-primary-color))', fontSize: '12px' }}
          >
            <a href={DOWNLOAD_STATEMENT_URL} target="_blank" rel="noreferrer">
              下载器使用说明
            </a>
          </div>
        )}
        <Tooltip label="如果出现点击没反应，请从桌面快捷方式打开，或参照下载器使用说明">
          <div
            className="mt-2 cursor-pointer"
            style={{ color: 'rgb(var(--ow-primary-color))', fontSize: '12px' }}
          >
            <a href={`${protocolName}://${window.location.href}`}>
              已安装，直接打开
            </a>
          </div>
        </Tooltip>
      </Modal>
    </>
  )
}

export default Exporter
